export type LayoutPoint = { x: number; z: number };

export type RoadLayout = {
  width: number;
  points: LayoutPoint[];
};

export type FieldLayout = {
  x: number;
  z: number;
  width: number;
  depth: number;
  rotation: number;
};

export const ROAD_LAYOUTS: RoadLayout[] = [
  {
    width: 7.5,
    points: [
      { x: -520, z: -120 },
      { x: -260, z: -60 },
      { x: 20, z: 40 },
      { x: 260, z: 120 },
      { x: 520, z: 180 },
    ],
  },
  {
    width: 6.8,
    points: [
      { x: -120, z: -520 },
      { x: -40, z: -260 },
      { x: 80, z: 10 },
      { x: 160, z: 260 },
      { x: 220, z: 520 },
    ],
  },
  {
    width: 5.8,
    points: [
      { x: -420, z: 360 },
      { x: -190, z: 250 },
      { x: 40, z: 210 },
      { x: 220, z: 250 },
      { x: 420, z: 330 },
    ],
  },
];

export const FIELD_LAYOUTS: FieldLayout[] = [
  { x: -640, z: -180, width: 128, depth: 96, rotation: 0.22 },
  { x: -520, z: 120, width: 144, depth: 88, rotation: -0.18 },
  { x: -420, z: 520, width: 116, depth: 90, rotation: 0.42 },
  { x: -170, z: 640, width: 156, depth: 108, rotation: -0.12 },
  { x: 140, z: 600, width: 126, depth: 104, rotation: 0.16 },
  { x: 360, z: 500, width: 144, depth: 118, rotation: 0.28 },
  { x: 620, z: 320, width: 118, depth: 86, rotation: -0.24 },
  { x: 610, z: -80, width: 148, depth: 112, rotation: 0.08 },
  { x: 420, z: -360, width: 162, depth: 100, rotation: -0.32 },
  { x: 80, z: -610, width: 124, depth: 102, rotation: 0.1 },
  { x: -260, z: -620, width: 154, depth: 114, rotation: -0.22 },
  { x: -560, z: -420, width: 132, depth: 94, rotation: 0.3 },
];

export const LANDMARK_LAYOUT = {
  waterTower: { x: 240, z: -220 },
  relayTower: { x: -300, z: 330 },
  storageTanks: { x: 310, z: 245 },
  hangars: [
    { x: -120, z: 170, rotation: 0.28 },
    { x: 120, z: -110, rotation: -0.18 },
  ],
  motorPool: { x: -360, z: -250, rotation: 0.22 },
  substation: { x: -210, z: 265, rotation: 0.14 },
} as const;
